import { Home, MessageCircle, Award, Wrench } from 'lucide-react';
import { valueProps } from '../mock';

const iconMap = {
  Home,
  MessageCircle,
  Award,
  Wrench
};

export const ValueProps = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            What Sets Me Apart
          </h2>
          <p className="text-xl text-gray-600">
            I'm not just another PC shop. I'm your local technology partner committed 
            to excellence in every build and repair.
          </p>
        </div>

        {/* Value Props Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {valueProps.map((prop, index) => {
            const IconComponent = iconMap[prop.icon];
            return (
              <div
                key={prop.id}
                className="group bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {prop.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {prop.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-8 border border-amber-200">
            <p className="text-2xl font-bold text-gray-900 mb-2">
              Let's Build Something Great Together
            </p>
            <p className="text-gray-600">
              Quality workmanship and honest service for your PC needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};